import React from 'react';
import styles from './index.less';
import rateIcon from '../../assets/rateIcon.png';
import starIcon from '../../assets/starIcon.png';
import greyStar from '../../assets/greyStar.png';
import intl from 'react-intl-universal';

interface SatisfactionProps {
  satisfactionData: any[];
  updateSatisfaction: (satisfaction: number, index: number) => React.ReactNode;
  isAllEmptyShowTip: boolean;
}
function Satisfaction({ satisfactionData, updateSatisfaction, isAllEmptyShowTip }: SatisfactionProps) {
  // 满意度渲染函数
  const satisfactionRender = (satisfaction: number, index: number) => {
    return (
      <div className={styles['signInContentSatisfactionStarBox']}>
        {
          [1,2,3,4,5].map((item) => {
            return (
              <div className={styles['signInContentSatisfactionStar']} onClick={() => updateSatisfaction(index, item)}>
                <img src={item <= satisfaction ? starIcon : greyStar} alt="" />
              </div>
            )
          })
        }
      </div>
    )
  }
  return (
    <div className={styles['signInContentSatisfactionBox']}>
      {/* 满意度调查 */}
      <div className={styles['signInContentSatisfaction']}>
        <div className={styles['signInContentHead']}>
          <img src={rateIcon} alt="" className={styles['signInContentHeadIcon']} />
          <span>{intl.get('qrcode.signIn.titleQuestion')}</span>
        </div>
        {
          satisfactionData.map((item, index) => {
            return (
              <div>
                <div className={[styles['signInContentSatisfactionItem']].join(' ')}>
                  <div className={styles['signInContentSatisfactionTitle']}>
                    { item.title }
                  </div>
                  {/* 满意度星星可点击 */}
                  {satisfactionRender(item.satisfaction, index)}
                </div>
                <div
                  className={[
                    styles['signInContentSatisfactionLine'],
                    index === satisfactionData.length - 1 && !(isAllEmptyShowTip && item.satisfaction === 0) ? styles['signInContentSatisfactionItemNoneBorder'] : '',
                    isAllEmptyShowTip && item.satisfaction === 0 ? styles['signInContentSatisfactionLineRed'] : ''
                  ].join(' ')}>
                  { isAllEmptyShowTip && item.satisfaction === 0 ? intl.get('qrcode.signIn.emptyContent3') : '' }
                </div>
              </div>
              
            )
          })
        }
      </div>
    </div>
  )
}

export default Satisfaction